/* eslint-disable jira/filename-case */
export const RESULTS = {
	SUCCESS: 'success',
	FAILURE: 'failure',
};
